import { useInfiniteQuery } from "@tanstack/react-query";
import { useMemo, useState } from "react";
import { http } from "../../../../../../services/HttpService";
import {
  HTTP_ENDPOINTS,
  ORDER_TYPES,
  QUERY_KEYS,
} from "../../../../../../consts/api";
import { removeNullishFromShape } from "../../../../../../utilities/general";

export const useMembershipSavingsReport = (params, options = {}) => {
  const [order, setOrder] = useState({
    by: "",
    direction: "",
  });

  const res = useInfiniteQuery({
    queryKey: [QUERY_KEYS.salesMembershipReports, params, order],
    queryFn: async ({ pageParam = 1 }) => {
      const res = await http.post(
        HTTP_ENDPOINTS.getSalesMembershipSavingsReports(),
        removeNullishFromShape({
          ...params,
          page: pageParam,
          pagesize: 15,
          sortBy: order.by,
          order: order.direction,
        }),
      );

      const composeResponse = {
        clinics: res.data.data.clinics,
        reportData: res.data.data.report.data,
        report: res.data.data.report,
      };
      return composeResponse;
    },
    staleTime: 0,
    cacheTime: 0,
    keepPreviousData: true,
    ...options,
    getNextPageParam: (_lastPage, pages) => {
      const lastPage = pages[0].report.last_page;
      if (pages.length < lastPage) {
        return pages.length + 1;
      }
      return null;
    },
  });

  const updateOrder = (orderFieldKey) => {
    setOrder({
      by: orderFieldKey,
      direction:
        order.direction === ORDER_TYPES.desc
          ? ORDER_TYPES.asc
          : ORDER_TYPES.desc,
    });
  };

  const report = useMemo(() => {
    if (res?.data?.pages) {
      return res?.data?.pages.flatMap((p) => p.report);
    }
    return [];
  }, [res?.data?.pages]);

  const reportData =
    useMemo(() => report?.flatMap((r) => r.data), [report]) || [];

  const isSoftLoading =
    res.isFetching && !res.isLoading && !res.isFetchingNextPage;

  return {
    data: reportData,
    clinics: res.data?.pages?.[0]?.clinics || [],
    isLoading: res.isLoading,
    isSoftLoading,
    order: {
      value: order,
      update: updateOrder,
    },
    isNextFetching: res.isFetchingNextPage,
    hasMorePage: Boolean(res.hasNextPage),
    fetchMore: res.fetchNextPage,
  };
};
